module.exports = __webpack_public_path__ + "static/media/Helmi.344fb91a.jpg";